import React from 'react';
import TermsOfServiceHero from './TermsOfServiceHero';
import TermsOfServiceSection from './TermsOfServiceSection';
import Footer from '../../components/Footer';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-page">
      <TermsOfServiceHero />
      <TermsOfServiceSection />
      <Footer />
    </div>
  );
};

export default TermsOfService; 